import React, { useState } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import Logo from '../components/Logo'

function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [msg, setMsg] = useState('')
  const [error, setError] = useState('')
  const { t } = useTranslation()

  // Robust gegen baseURL-/Proxy-Varianten:
  // - Wenn AUTH_BASE relativ ist (/auth), wird window.location.origin genutzt
  // - Wenn AUTH_BASE absolut ist (https://...), wird es direkt genutzt
  const AUTH_BASE =
    process.env.REACT_APP_AUTH_API_URL ||
    process.env.REACT_APP_AUTH_API ||
    '/auth'

  function buildAuthUrl(path) {
    const base = String(AUTH_BASE || '').replace(/\/+$/, '')
    const p = String(path || '').startsWith('/') ? path : `/${path}`

    if (/^https?:\/\//i.test(base)) return `${base}${p}`
    return new URL(`${base}${p}`, window.location.origin).toString()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setMsg('')

    const cleanEmail = String(email || '').trim()

    try {
      await axios.post(
        buildAuthUrl('/forgot-password'),
        { email: cleanEmail },
        { withCredentials: true }
      )

      // NIEMALS das Response-Objekt rendern -> immer String
      setMsg(
        t('forgotPassword.success', {
          defaultValue:
            'Wenn die E-Mail existiert, wurde ein Link zum Zurücksetzen versendet.',
        })
      )
    } catch (err) {
      const data = err?.response?.data

      // Server kann string | {error: "..."} | html liefern -> immer String bauen
      let message = ''
      if (typeof data === 'string') message = data
      else if (data && typeof data === 'object' && data.error) message = String(data.error)
      else {
        message = t('forgotPassword.error', {
          defaultValue: 'Das hat nicht geklappt. Bitte versuche es erneut.',
        })
      }

      setError(message)
    }
  }

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-white">
      <div className="mb-10">
        <Logo variant="wordmark" size="xxxl" />
      </div>

      <h2 className="text-3xl md:text-4xl font-bold mb-8">
        {t('forgotPassword.heading')}
      </h2>

      {error && (
        <div className="bg-red-600 text-white px-4 py-2 rounded-2xl mb-6">
          {error}
        </div>
      )}

      {msg && (
        <div className="bg-green-600 text-white px-4 py-2 rounded-2xl mb-6">
          {msg}
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="bg-gray-800 p-8 rounded-2xl shadow-md w-full max-w-md"
      >
        <div className="mb-6">
          <label className="block mb-2 font-semibold">
            {t('forgotPassword.emailLabel')}
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-3 rounded bg-gray-700 text-white focus:outline-none"
            placeholder={t('forgotPassword.emailPlaceholder')}
          />
        </div>

        <button
          type="submit"
          className="w-full bg-mentixxgreen hover:bg-green-400 text-black font-bold py-3 rounded-2xl transition"
        >
          {t('forgotPassword.requestButton')}
        </button>
      </form>
    </div>
  )
}

export default ForgotPasswordPage
